<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-kaia-logo="false"
  >
    <template #header_end><HeaderHelp /></template>
    <BaseContentCard
      :title="$t('eu__doctor_outreach__assessment_completed__title')"
      :description="
        $t('eu__doctor_outreach__assessment_completed__description')
      "
      class="kds-color-background-teal-subtle"
    >
      <template #illustration>
        <div
          role="img"
          aria-label="Assessment Complete"
          v-html="illustrationSvg"
        />
      </template>
    </BaseContentCard>
    <template #actions>
      <BaseButton
        :loading="isLoading"
        @click="props.handleNextEvent"
      >
        {{ $t('generic_action_continue') }}
      </BaseButton>
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import BaseContentCard from '@shared/components/BaseContentCard.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import { submitSelfTestAnswers } from '@shared/modules/assessment/submitSelfTest.js'
import illustrationSvg from '@shared/assets/img/pre-activation-assessment-complete.svg?raw'

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const isLoading = ref(true)

onMounted(async () => {
  try {
    await submitSelfTestAnswers('full')
  } catch (error) {
    console.error('Failed to submit self test:', error)
  } finally {
    isLoading.value = false
  }
})
</script>
